import type { PickerCatalog } from './types'

export const catalogName = (catalog: PickerCatalog) =>
  catalog.display_name?.trim() || 'Untitled catalog'

export const filterCatalogs = (catalogs: PickerCatalog[], query: string) => {
  const q = query.trim().toLowerCase()
  if (!q) return catalogs
  return catalogs.filter(c => catalogName(c).toLowerCase().includes(q))
}

export const toggleId = <T>(ids: T[], id: T): T[] =>
  ids.includes(id) ? ids.filter(i => i !== id) : [...ids, id]
